import styled, { css } from 'styled-components';

export const Divider = styled('hr')(
  ({ theme }) => css`
    margin: 0;
    border: none;
    border-top: 1px solid ${theme.palette.neutral[500]};
  `,
);
